export default "__VITE_ASSET__1843a239__"